import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'animate.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import '././assets/js/myscript.js';

import '././assets/css/icofont.min.css';
import '././assets/css/mystyle.css';
import '././assets/css/animate.css';
import '././assets/css/style.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    
    <App />
   
    
  </React.StrictMode>
);

reportWebVitals();
